<template>
  <div class="hdrGen">
    <!-- Auslöser im Header: Icon + Anzahl laufender Generierungen; öffnet den Generieren-Dialog -->
    <button type="button" class="hdrGen__trigger" :class="{ open, busy: running }" :title="running ? `${running} Generierung${running === 1 ? '' : 'en'} laufen` : 'Generieren'" @click="toggle">
      <v-progress-circular v-if="running" indeterminate size="16" width="2" color="#7b5cd6" />
      <v-icon v-else small>mdi-auto-fix</v-icon>
      <span>Generieren</span>
      <span v-if="running" class="hdrGen__badge">{{ running }}</span>
    </button>

    <!-- Inhalt bleibt nach dem ersten Öffnen erhalten (Fotos, Stil, Ergebnisse), Läufe laufen im Store weiter -->
    <v-dialog v-model="open" width="1480" max-width="97vw" content-class="hdrGen__dialog" :retain-focus="false">
      <GenerateView v-if="opened" embedded @close="open = false" />
    </v-dialog>
  </div>
</template>

<script>
import GenerateView from "@/views/GenerateView.vue";
import { generateRuns } from "@/generateRuns";

export default {
  name: "HeaderGenerate",
  components: { GenerateView },
  data: () => ({ open: false, opened: false }),
  computed: {
    running() {
      return generateRuns.runs.length;
    },
  },
  methods: {
    toggle() {
      this.opened = true;
      this.open = !this.open;
    },
  },
};
</script>

<style lang="scss" scoped>
.hdrGen {
  position: relative;
  margin-right: 12px;

  &__trigger {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 40px;
    padding: 0 14px;
    border-radius: 999px;
    background: #f4f3f7;
    font-size: 14px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.65);
    transition: background 0.15s, box-shadow 0.15s;

    &:hover,
    &.open,
    &.busy {
      background: #edeafa;
      color: #6a4fc4;
    }
  }
  &__badge {
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    border-radius: 999px;
    background: #7b5cd6;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    line-height: 20px;
    text-align: center;
  }
}
</style>

<style lang="scss">
/* Dialog-Hülle (nicht scoped: content-class liegt außerhalb der Komponente) */
.hdrGen__dialog {
  border-radius: 18px !important;
  background: #f4f5f8;
  max-height: 92vh !important;
  overflow-y: auto;
}
</style>
